import FormField from './FormField';

export default class FormFieldLongText extends FormField
{

}
